import { PaymentSetupResponseStatus } from 'obt-common/types/api/v2/obt/model/payment-setup-response-status';

interface IProps {
  status: PaymentSetupResponseStatus;
  fopRuleIndex: number;
  paymentRuleIndex: number;
}

export function getCvvJsonPath({ status, fopRuleIndex, paymentRuleIndex }: IProps): string {
  let cvvJsonPath = '';

  if (status === PaymentSetupResponseStatus.CvvRequired) {
    cvvJsonPath = 'card.cvv';
  } else if (status === PaymentSetupResponseStatus.SupplierCvvRequired) {
    if (fopRuleIndex === -1 || paymentRuleIndex === -1) {
      cvvJsonPath = 'bookingCharges[0].selectedPaymentSource.cvv';
    } else {
      cvvJsonPath = `bookingPaymentDetails.bookingTravelerPaymentDetails[0].selectedFops[${fopRuleIndex}].selectedPayments[${paymentRuleIndex}].cvv`;
    }
  }

  return cvvJsonPath;
}
